<template>
	<article>
    <header class="view__header">
      <h2 class="view__title">{{ parsedData.email }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <submenu v-if="this.$route.params.id"></submenu>
        <div class="form js-form view__split">
          <div class="jquery-alpaca" />
        </div>
        <div class="form js-form view__split">
          <h2 class="view__title--sub">{{ L.localize("Label_MemberData") }}</h2>
          <fieldset class="form__field">
            <div class="tags">
              <span class="tags__item tags__item--active" v-if="member.isActive">{{ L.localize("MemberData_IsActive") }}</span>
              <span class="tags__item tags__item--inactive" v-else>{{ L.localize("MemberData_IsNotActive") }}</span>
            </div>
          </fieldset>

          <fieldset class="form__field">
            <label class="form__label">
              {{ L.localize("Members_Groups") }}
            </label>
            <div class="tags">
              <span class="tags__item" v-for="group in member.groups">{{ group.name }}</span>
            </div>
          </fieldset>

          <fieldset class="form__field">
            <label class="form__label">
              {{ L.localize("Members_Subscription") }}
            </label>
            <div class="tags">
              <span class="tags__item tags__item--active" v-if="!member.unsubscribed">{{ L.localize("Label_Subscribed") }}</span>
              <span class="tags__item tags__item--inactive" v-else>{{ L.localize("Label_Unsubscribed") }}</span>
            </div>
          </fieldset>

          <fieldset class="form__field">
            <label class="form__label">
              {{ L.localize("MemberData_CreationTime") }}
            </label>
            <p>{{ Format.date(member.creationTime) }}</p>
          </fieldset>

          <fieldset class="form__field">
            <label class="form__label">
              {{ L.localize("MemberData_LastModificationDate") }}
            </label>
            <p>{{ Format.date(member.lastModificationTime) }}</p>
          </fieldset>
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import { CheckBox } from 'components/layout/forms'
import { mapGetters } from 'vuex'
import Submenu from 'components/views/members/Submenu'
import alpaca from 'alpaca'
import L from 'services/Localization'
import Format from 'services/Format'

export default {
  name: 'member-detail',
  components: { Submenu, CheckBox },
  data() {
    return {
      L: L,
      Format: Format,
      alpaca: alpaca,
      loading: '',
      title: '',
      schema: {},
      options: {},
      parsedData: {}
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch('getMember', this.$route.params.id).then(() => {
        this.mapFromState()
      })
    }
  },
  computed: {
    ...mapGetters({
      member: 'activeMember',
      validation: 'getValidation'
    })
  },
  beforeDestroy() {
    $('.jquery-alpaca').alpaca('destroy');
  },
  methods: {
    mapFromState() {
      this.schema = JSON.parse(this.member.schema)
      this.options = JSON.parse(this.member.options)
      this.parsedData = JSON.parse(this.member.data)
      this.init()
    },
    init() {
      $('.jquery-alpaca').alpaca({
        'data': this.parsedData,
        'schema': this.schema,
        'options': this.options,
        'view': 'templ-display'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MemberDetail.vue?df6db04e